export default __webpack_public_path__ + "static/media/973.e813fd59.jfif";